import React, { FunctionComponent, useContext, useState } from "react";
import { RouteComponentProps, withRouter } from "react-router";
import { Button, Dialog } from "@cmsgov/ds-medicare-gov";
import { useTranslate } from "../../../helpers";
import { County, ActionType } from "../../../@types";
import { Routes } from "../../../app";
import { AppContext } from "../../../app/store";
import ChangeLocationStatePicker from "./ChangeLocationStatePicker";
import {
  AnalyticsActionType,
  AnalyticsButtonStyle,
  AnalyticsButtonType,
} from "../../../app/contexts/Analytics/types";

const MedigapChangeLocation: FunctionComponent<RouteComponentProps> = ({
  history,
}) => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const { dispatch } = useContext(AppContext);
  const t = useTranslate();

  const onChangeLocation = (): void => {
    dispatch({
      type: AnalyticsActionType.SEND_TEALIUM_EVENT,
      settings: {
        event_action: "Step 1: Decide what plans you want",
        event_label: "UI Option: Change location",
      },
    });
    setShowModal(true);
  };

  const onStateSelect = (county: County, zipcode: string): void => {
    setShowModal(false);

    dispatch({ type: ActionType.UPDATE_COUNTY, payload: county });
    dispatch({ type: ActionType.UPDATE_FIPS, payload: county.fips });
    dispatch({ type: ActionType.UPDATE_ZIPCODE, payload: zipcode });

    history.push(Routes.medigap.plans);
  };

  return (
    <div className="MedigapChangeLocation__link">
      <Button
        variation="ghost"
        onClick={() => {
          dispatch({
            type: AnalyticsActionType.SEND_BUTTON_ENGAGEMENT_EVENT,
            settings: {
              button: {
                buttonStyle: AnalyticsButtonStyle.TRANSPARENT,
                buttonType: AnalyticsButtonType.BUTTON,
                text: t("medigap.change_location.link_text"),
              },
            },
          });
          onChangeLocation();
        }}
      >
        {t("medigap.change_location.link_text")}
      </Button>

      {showModal && (
        <Dialog
          heading={t("medigap.change_location.title.change_location")}
          className="MedigapChangeLocation__modal"
          headerClassName="SelectStateModal__header"
          escapeExits={false}
          underlayClickExits={false}
          onExit={(): void => setShowModal(false)}
        >
          <ChangeLocationStatePicker onStateSelection={onStateSelect} />
        </Dialog>
      )}
    </div>
  );
};

export default withRouter(MedigapChangeLocation);
